// Modules
import { useState } from "react";

// App
import PageHeader from "../../partials/pageHeader";
import ClientTheme from "../../core/clientTheme";

// UI components

export default function Fiori(props) {
  const [isLoading, setLoading] = useState(true);
  const clientTheme = { ...ClientTheme() };

  return (
    <>
      <main className="fiori screen">
        <PageHeader
          pageName="My HR Services"
          filters={true}
          owner="client"
          pageNameColor="clientHeadingScreens"
          svgLogo={clientTheme.pageLogos.svg}
          pageLogo={clientTheme.pageLogos.news}
        />

        <iframe
          className={`w-100 ${isLoading && "invisible"}`}
          style={{ minHeight: 500 }}
          src={'https://fioridev.equans.co.uk'}
          title={`My HR Services`}
          frameBorder="0"
          onLoad={(iframe) => {
            if (iframe.target.contentWindow) {
              // iframe.target.style.height =
              //   iframe.target.contentWindow.document.body.scrollHeight +
              //   "px";
            }

            setLoading(false);
          }}
        />
      </main>
    </>
  );
}
